import { z } from 'zod';

const isProduction = import.meta.env.PROD;

const apiBaseUrlSchema = isProduction
  ? z.url().refine((value) => value.startsWith('https://'), {
      message: 'VITE_API_BASE_URL must use https:// in production',
    })
  : z.url();

const publicEnvSchema = z.object({
  appUrl: z.url().default('http://localhost:3000'),
  chatUrl: z.url().default('http://localhost:3004'),
  appName: z.string().default('Devizy'),
  apiBaseUrl: apiBaseUrlSchema,
  vapidPublicKey: z.string().optional(),
  paddleClientToken: z.string().optional(),
  paddleEnvironment: z.enum(['sandbox', 'production']).default('sandbox'),
});

export const publicEnv = publicEnvSchema.parse({
  appUrl: import.meta.env.VITE_APP_URL,
  chatUrl: import.meta.env.VITE_CHAT_URL,
  appName: import.meta.env.VITE_APP_NAME,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  vapidPublicKey: import.meta.env.VITE_VAPID_PUBLIC_KEY,
  paddleClientToken: import.meta.env.VITE_PADDLE_CLIENT_TOKEN || undefined,
  paddleEnvironment: import.meta.env.VITE_PADDLE_ENVIRONMENT || undefined,
});
